module.exports = __webpack_public_path__ + "static/media/travel-insurance.79c9a2d6.svg";